import decode from 'jwt-decode';
import {getErrors} from '../utils/tools';
import {login,register,getUser,updateUser,refreshToken} from '../api/auth';

/*
  Met à jour les informations de l'utilisateur
*/
export function updateUserAction(user_id, data)
{
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      if(!token || !user_id){
        dispatch({
            type:"UPDATE_ISLOGGEDIN",
            isLoggedIn:false
        });
      } else {
        return updateUser(user_id, data, token)
          .then(res => {
            /* Vérifie si des informations sont manquantes */
            dispatch({
                type:"USER_INFO_MISSING",
                userInfoMissing:false
            });
            for (var i in data) {
              if (data[i] === null || data[i] === "" || (data[i] && data[i].constructor === Object && Object.keys(data[i]).length === 0)){
                dispatch({
                    type:"USER_INFO_MISSING",
                    userInfoMissing:true
                });
                break;
              }
            }
            /****/
          dispatch({
              type:"UPDATE_USER",
              user:res
          })
            this.displaySnackbar("success", "Mise à jour réussie");
          })
          .catch((err)=>{
            let errors = getErrors(err)
            this.displaySnackbar("error", errors[0].message);
            throw err
          })
        }
    })
  }

}

/*
  Enregistre un nouvel utilisateur
*/
export function registerAction(data)
{
  return(dispatch)=>{
    return register(data)
      .then(res => {
        this.displaySnackbar("success", res.message);
      })
      .catch((err)=>{
        let errors = getErrors(err)
        this.displaySnackbar("error", errors[0].message);
        throw err
      })
  }
}

/*
  Connexion de l'utilisateur
*/
export function loginAction(username, password)
{
  return(dispatch)=>{
    return login(username, password)
      .then(res => {
        localStorage.setItem('id_token', res.token)
        localStorage.setItem('refresh_token', res.refresh_token)
        localStorage.setItem('user_id', decode(res.token).userId)
        dispatch({
            type:"UPDATE_USER",
            user:res
        })
        dispatch({
            type:"UPDATE_ISLOGGEDIN",
            isLoggedIn:true
        });
      })
      .catch((err)=>{
        let errors = getErrors(err)
        this.displaySnackbar("error", errors[0].message);
        throw err
      })
  }
}

/*
  Affiche une fenêtre de confirmation
  string title : Un titre
  string msg : Un message
  fn() callback : une fonction à appeler lors de la validation
*/
export function displayConfirmation(title,msg,callback)
{
    return(dispatch)=>{
      dispatch({
          type:"SHOW_CONFIRMATION",
          title:title,
          message: msg,
          callback:callback
      });
    }
}

/*
  Ferme la fenêtre de confirmation
*/
export function closeConfirmation()
{
    return(dispatch)=>{
      dispatch({
          type:"CLOSE_CONFIRMATION"
      });
    }
}

/*
  Affiche un popup d'information
  string type : success|error
  string msg : Un message
*/
export function displaySnackbar(type,msg,manual_close)
{
    return(dispatch)=>{
      dispatch({
          type:"SHOW_SNACKBAR",
          msg_type:type,
          message: msg
      });
      if(!manual_close)
        setTimeout(this.closeSnackbar, 3000)
    }
}

/*
  Ferme la popup
*/
export function closeSnackbar()
{
    return(dispatch)=>{
      dispatch({
          type:"CLOSE_SNACKBAR"
      });
    }
}

/*
  Vérifie si le token et le refresh_token sont en cache,
  ensuite vérifie la validité du token sinon on en demande
  un nouveau. Dans le cas contraire on déconnecte l'utilisateur
*/
export function loggedIn()
{
    return(dispatch)=>{
      // Checks if there is a saved token and it's still valid
      const token = localStorage.getItem("id_token") // Getting token from localstorage
      const refresh_token = localStorage.getItem("refresh_token") // Getting token from localstorage

      /* SI aucun token en cache */
      if (!token || !refresh_token) {
        dispatch({
            type:"UPDATE_ISLOGGEDIN",
            isLoggedIn:false
        });
        return new Error('err');
      } else {
        /* Si le token a expiré alors on en demande un nouveau */
        if(!(!!token && !isTokenExpired(token))){
          console.log("expired")
          return this.refreshTokenAction(refresh_token)
        } else {
          dispatch({
              type:"UPDATE_ISLOGGEDIN",
              isLoggedIn:true
          });
          return Promise.resolve("ok");
        }
      }

    }
}

/*
  Vérifie si le token est valide
*/
export function isTokenExpired(token)
{
    try {
        const decoded = decode(token);
        if (decoded.exp < Date.now() / 1000) { // Checking if token is expired.
            return true;
        }
        else
            return false;
    }
    catch (err) {
        return false;
    }
}

/*
  Demande un nouveau token en utilisant le refresh_token en cache
*/
export function refreshTokenAction(refresh_token)
{
  return(dispatch)=>{

    return refreshToken(refresh_token)
      .then((res)=>{
          console.log("new token")
          localStorage.setItem('id_token', res.token)
          localStorage.setItem('refresh_token', res.refresh_token)
          localStorage.setItem('user_id', decode(res.token).userId)
          dispatch({
              type:"UPDATE_ISLOGGEDIN",
              isLoggedIn:true
          });
      })
      .catch((err)=>{
        console.log("err token")
        localStorage.removeItem('id_token');
        localStorage.removeItem('refresh_token');
        dispatch({
            type:"UPDATE_ISLOGGEDIN",
            isLoggedIn:false
        });

        //let errors = getErrors(err)
        //this.displaySnackbar("error", errors[0].message);
        throw err
      })

  };
}

/*
  Récupère les information de l'utilisateur
*/
export function getUserAction()
{
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
        const token = localStorage.getItem("id_token")
        const user_id = localStorage.getItem("user_id")
      return getUser(user_id, token)
        .then(res => {
          dispatch({
              type:"UPDATE_USER",
              user:res
          });
          /* Vérifie si des informations sont manquantes */
          dispatch({
              type:"USER_INFO_MISSING",
              userInfoMissing:false
          });
          for (var i in res) {
            if (res[i] === null || res[i] === "" || (res[i] && res[i].constructor === Object && Object.keys(res[i]).length === 0)){
              dispatch({
                  type:"USER_INFO_MISSING",
                  userInfoMissing:true
              });
              break;
            }
          }
          /****/
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })

      })
    }
}

/*
  Suppresion des token en cache et redirection sur la page login
*/
export function logout()
{
    // Clear user token and profile data from localStorage
    return(dispatch)=>{
      localStorage.removeItem('id_token');
      localStorage.removeItem('refresh_token');
      dispatch({
          type:"UPDATE_USER",
          user:{}
      });
      dispatch({
          type:"UPDATE_ISLOGGEDIN",
          isLoggedIn:false
      });
    }
}

/*
  Met à jour l'état du loader
*/
export function updateLoading(loading)
{
    return(dispatch)=>{
        dispatch({
            type:"UPDATE_LOADING",
            loading:loading
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/index.js